export default "__VITE_ASSET__BMLtZHTu__"